// extracted by mini-css-extract-plugin
export default {"container":"Heading_container__dltwg","buttonContainer":"Heading_buttonContainer__NdG2K"};